import { Common } from '../../middleware/index'
import appointDialog from "@/components/dialog/appoint/index"
interface Booking {
    provinceCode:string;
    cityCode:string;
    carType:string;
    userName:string;
    userPhone:string;
    storeCode:string;
}

export class AnnualAccount extends Common {
    public get request(){
        return (this as any).$axios
    }

    public showAppointDialog(data:any){
        return new Promise((resolve)=>{
            appointDialog();
        })
    }
    public travelInfo(){
        return new Promise((resolve)=>{
            this.request.get('faw/travelInfo',{}).then((res:any)=>{
                if(res.code!=200){
                    (this as any).$dialog.alert({
                        message: res.message
                    })
                }else{
                    resolve(res.data);
                }
            })
            
        })
    }

    public async getUserInfo() {
        return new Promise((resolve)=>{
            this.request.get('user/nickname',{}).then((res:any)=>{
                resolve(res);
            })
            
        })
    }
}